import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { parseEntityRef, stringifyEntityRef } from '@backstage/catalog-model';
import { useEntity } from '@backstage/plugin-catalog-react';
import { makeStyles } from 'tss-react/mui';
import { getColors } from '@mercedes-benz/odp-theme-v2';
import { EntityRelationsGraph } from '@backstage/plugin-catalog-graph';

const useStyles = makeStyles()(theme => {
  const c = getColors(theme.palette.mode);
  return {
    root: {
      padding: 0,
    },
    header: {
      color: c.text.primary,
      fontWeight: 600,
      fontSize: '1.1rem',
      marginBottom: 16,
      marginTop: 0,
      userSelect: 'none',
    },
    container: {
      background: c.background.paper,
      borderRadius: 12,
      border: `1px solid ${c.border.default}`,
      padding: 24,
      minHeight: 400,
    },
  };
});

export const RelationsTab = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { entity } = useEntity();

  const rootEntityNames = parseEntityRef(stringifyEntityRef(entity));

  const handleNodeClick = useCallback(
    (node: { id: string }) => {
      const ref = parseEntityRef(node.id);
      navigate(
        `/catalog/${ref.namespace}/${ref.kind.toLowerCase()}/${ref.name}`,
      );
    },
    [navigate],
  );

  return (
    <div className={classes.root}>
      <h3 className={classes.header}>Relations</h3>
      <div className={classes.container} style={{ height: 500 }}>
        <EntityRelationsGraph
          rootEntityNames={rootEntityNames}
          maxDepth={1}
          onNodeClick={handleNodeClick as any}
        />
      </div>
    </div>
  );
};
